import { Quill } from 'react-quill';

const BlockEmbed = Quill.import('blots/block/embed');

class GridBlot extends BlockEmbed {
  static blotName = 'gridBlot';
  static tagName = 'p';
  static className = 'ql-grid';

  static create(value: { elements: HTMLElement[]; gridType: 'grid-2' | 'grid-3' }) {
    const container = document.createElement('p');
    const gridClass = value.gridType === 'grid-2' ? 'ql-grid-2' : 'ql-grid-3';

    container.classList.add(this.className, gridClass);
    container.setAttribute('contenteditable', 'false');

    value.elements.forEach(element => {
      const clone = element.cloneNode(true) as HTMLElement;
      container.appendChild(clone);
    });

    return container;
  }
  static value(node: HTMLElement) {
    const elements = Array.from(node.children).map(child => child.cloneNode(true) as HTMLElement);
    const gridType = node.classList.contains('ql-grid-2') ? 'grid-2' : 'grid-3';

    return { elements, gridType };
  }

  static formats() {
    return null; // 🚫 No formatting allowed
  }

  format() {
    return; // 🚫 Do nothing (prevents inline edits)
  }

  deleteAt(index: number, length: number) {
    super.deleteAt(index, length);
  }
}

Quill.register(GridBlot);
